/**
 * CampaignPerformanceChart - Bar chart comparing campaign signups
 */
import { getThemeByKey, LEGACY_CAMPAIGN_THEMES } from './campaignUtils';

export default function CampaignPerformanceChart({ report }) {
  if (!report?.campaigns?.length) return null;

  return (
    <div className="bg-card rounded-2xl p-6 shadow-sm border border-border mb-8">
      <h2 className="font-heading text-xl mb-6 text-foreground">Campaign Performance</h2>
      <div className="space-y-4">
        {report.campaigns.map(campaign => {
          const maxSignups = Math.max(...(report.campaigns.map(c => c.signups) || [1])) || 1;
          const percentage = (campaign.signups / maxSignups) * 100;
          const themeKey = campaign.theme || 'teal';
          const themeOption = getThemeByKey(themeKey);
          const theme = LEGACY_CAMPAIGN_THEMES[campaign.campaign_id] || {
            gradient: themeOption.gradient,
            color: themeOption.textColor,
            bg: themeOption.bg,
            border: themeOption.border
          };
          
          return (
            <div key={campaign.campaign_id} className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="font-medium text-foreground">Campaign {campaign.campaign_id}</span>
                <span className={theme.color}>{campaign.signups} signups</span>
              </div>
              <div className="h-4 bg-muted rounded-full overflow-hidden">
                <div 
                  className={`h-full bg-gradient-to-r ${theme.gradient} rounded-full transition-all duration-500`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
